import axios from '../axios-init';

// 仓库对神医Service Fee设置的特殊价格
export const getDoctorUserList = params => {
    return axios.post(`/custom_service_fee_config/getDoctorUserList`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const getCustomServiceFeeList = params => {
    return axios.post(`/custom_service_fee_config/getServiceFeeList`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const getCustomServiceFeeById = params => {
    return axios.post(`/custom_service_fee_config/getServiceFeeById`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const editCustomServiceFeeConfigs = params => {
    return axios.post(`/custom_service_fee_config/addOrEditCustomServiceFeeConfigs`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const deleteCustomServiceFeeConfigs = params => {
    return axios.post(`/custom_service_fee_config/restoreCustomServiceFeeConfigs`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};



// WEBPACK FOOTER //
// ./src/api/customServiceFeeConfigService.js